<template>
	<div class="my_account bg-white">
		<div>
			<van-cell title="头像">
				<div class="avatar">
					<img v-if="info.headimg" :src="info.headimg" alt="" />
					<img v-else src="@/assets/img/default_avatar.png" alt="" />
				</div>
			</van-cell>
			<van-cell title="昵称" :value="info.nickname || '--'"></van-cell>
			<van-cell title="手机号" :value="info.phone"></van-cell>
		</div>

		<foot-button>
			<van-button type="primary" block plain @click="clickLogout">退出登录</van-button>
		</foot-button>
	</div>
</template>

<script>
	export default {
		name: 'MyAccount',
		data: () => ({
			info: {}
		}),
		mounted () {
			this.load()
		},
		methods: {
			async load () {
				const res = await this.$api.account.getWechatInfo()
				if (!res.code) {
					this.info = res.data
				}
			},
			clickLogout () {
				this.$dialog.confirm({
					title: '',
					message: '确认退出当前账号吗？',
					confirmButtonText: '退出'
				}).then(() => {
					return this.$api.account.logout()
				}).then(res => {
					if (!res.code) {
						this.$store.commit('account/CLEAR')
						this.$router.replace('/account/login')
					}
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped lang="less">
	.my_account {
		min-height: calc(100vh - 216px);
		padding: 40px;
		.avatar {
			>img {
				width: 80px;
				height: 80px;
				vertical-align: middle;
				border-radius: 50%;
			}
		}
	}
</style>

<style lang="less">
	.my_account {
		.van-cell {
			padding: 34px 0;
			align-items: center;
			&::after{
				left: 0;
				right: 0;
			}
			.van-cell__title {
				height: 42px;
				font-family: PingFangSC-Medium;
				font-size: 30px;
				font-weight: 500;
				color: #1F2329;
			}
			.van-cell__value {
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: #1F2329;
			}
		}
	}
</style>
